import useIsAdmin from 'hooks/useIsAdmin'
import { useRoleLocationScope } from 'hooks/useRoleLocationScope'

/**
 * Returns true if the current user is allowed to create/send/approve
 * message-to-everyone campaigns. Admins always can; non-admins can only
 * if they have no location restrictions (global scope).
 */
const useCanMessageEveryone = (): boolean => {
  const isAdmin = useIsAdmin()
  const { isGlobal } = useRoleLocationScope()
  return isAdmin || isGlobal
}

export default useCanMessageEveryone
